const INBOX = require('INBOX');

INBOX.namespace('classes.ContactsRemoteClient', function () {
    var ContactsRemoteClient = function (baseURL) {
        // Use proxy if <= IE9
        if (window.XDomainRequest) {
            baseURL = '';
        }

        INBOX.classes.RemoteClient.call(this, baseURL);

        var getContacts = function (email, options) {
            const page = options.page || 0;
            const limit = options.limit || 1;
            const sortTerms = options.sortTerms || ['displayName', 'asc'];
            const searchTerms = options.searchTerms || false;
            // MAIL-6424 - email variable pass user email only
            let url = `/contacts/v2/${email}?offset=${page * limit}&limit=${limit}`;

            if (options.fields && options.fields.length) {
                url += `&fields=${options.fields.join(',')}`;
            }

            if (sortTerms || searchTerms) {
                var query = {};
                if (sortTerms) {
                    query.sortTerms = sortTerms;
                }
                if (searchTerms) {
                    //CSS-248 - add exact param, always search strict email
                    searchTerms.exact = true;
                    query.searchTerms = searchTerms;
                }
                url += `&query=${encodeURIComponent(JSON.stringify(query))}`;
            }

            return this.request(url, 'GET', null, options.success, options.failure);
        };

        this.createContact = function (name, emails, source, success, failure) {
            var emailsList = [];
            $.each(emails, function (i, email) {
                emailsList.push({ 'address': email });
            });
            return this.createFromRaw({ 'displayName': name, 'emails': emailsList, 'source': source }, success, failure);
        };

        this.createRepliedContact = function (name, emails) {
            var emailsList = [];
            $.each(emails, function (i, email) {
                emailsList.push({ 'address': email });
            });
            return this.createFromRaw({ 'displayName': name, 'emails': emailsList, source: 'webmail', 'namedGroups': ['Replied'] });
        };
        this.createContactWithGroup = function (name, emails, selectedGroups) {
            var emailsList = [];
            $.each(emails, function (i, email) {
                emailsList.push({ 'address': email });
            });
            return this.createFromRaw({ 'displayName': name, 'emails': emailsList, source: 'webmail', 'namedGroups': selectedGroups });
        };

        this.createFromRaw = function (contact, success, failure) {
            contact.syncTag = this.getSyncTag();
            return this.request('/contacts', 'POST', contact, success, failure);
        };

        this.updateFromRaw = function (contact, success, failure) {
            contact.syncTag = this.getSyncTag();
            return this.request('/contacts/' + contact.id, 'PUT', contact, success, failure);
        };

        this.getExistingContacts = function (emails, success) {
            return this.request('/contacts/v2/_exists', 'POST', emails, success);
        };

        /**
         * Find contacts with not empty email and displayName. Return only displayName & email fields
         * @param {user} object
         */
        this.getContactsWithEmail = function (user, page, limit, searchString, success, failure) {
            return getContacts.call(this, user, {
                page: page,
                limit: limit,
                searchTerms: { 'or': { 'displayName': searchString, 'emails.address': searchString } },
                fields: ['displayName', 'emails.address'],
                success: success, failure: failure
            });
        };

        /**
         * @param {user} object
         */
        this.getContactsByEmail = function (user, email, success, failure) {
            return getContacts.call(email, user, {
                success, failure,
                searchTerms: { 'and': { 'emails.address': email } },
            });
        };

        this.getGroups = function (success, failure) {
            return this.request('/contacts/groups', 'GET', null, success, failure);
        };

        this.getContactsByGroup = function (user, groupId, limit, success, failure) {
            return getContacts.call(this, user, {
                'sortTerms': ['displayName', 'asc'],
                limit: limit,
                'searchTerms': { 'and': { 'groups': groupId } },
                fields: ['displayName', 'emails.address'],
                success: success, failure: failure
            });
        };

        this.deleteContacts = function () {
            return this.request('/contacts/sync/reset?really=all', 'DELETE', null);
        };
    };

    ContactsRemoteClient.prototype = new INBOX.classes.RemoteClient; // jshint ignore:line

    return ContactsRemoteClient;
});
